<importer-sub-header title="Settings"></importer-sub-header>

<div class="container">
  <div class="side-bar">
    <div
      style="z-index: 1; cursor: pointer; padding-top: 15px"
      (click)="openDashboardPage()">
      <span
        class="material-icons"
        style="color: white">
        fast_rewind
      </span>
    </div>
    <div style="display: flex; flex-direction: column"></div>
  </div>
  <div>
    <div>
      <ng-template #buttonsRightTemplate>
        <coin-v2-button
          [type]="'primary'"
          [icon]="'save'"
          [iconPos]="'right'"
          [text]="'Add New File Type'"
          (click)="openCreateFileTypePopup()"></coin-v2-button>
      </ng-template>
      <importer-button-footer [buttonsRightTemplate]="buttonsRightTemplate"></importer-button-footer>
    </div>
    <div class="records-details-container smaller">
      <div>
        <h4>Currently used File Types</h4>
        <div class="target-view">
          <div class="inner two">
            <div style="display: flex; justify-content: center; align-items: center">
              <importer-charts level="fileTypes"></importer-charts>
            </div>
            <div class="box mat-elevation-z4">
              <p class="bold head">Summary</p>
              <div class="content">
                <importer-filetype-overview [loading]="loading"></importer-filetype-overview>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
